// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__1gEFB"};